import { ComponentProps } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { DropdownField } from '@frontend/design-system';
import { monthlyWeekDayOptions } from '../types';

export const NthDayDropdown = (props: Omit<ComponentProps<typeof DropdownField>, 'label' | 'children'>) => {
  return (
    <DropdownField label={''} {...props} css={inlineDropdownStyles}>
      {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
        <DropdownField.Option key={day} value={String(day)}>
          {day}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

export const NthWeekDropdown = (props: Omit<ComponentProps<typeof DropdownField>, 'label' | 'children'>) => {
  return (
    <DropdownField label={''} {...props} css={inlineDropdownStyles}>
      {Array.from({ length: 52 }, (_, i) => i + 1).map((week) => (
        <DropdownField.Option key={week} value={String(week)}>
          {week}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

export const NthMonthDropdown = (props: Omit<ComponentProps<typeof DropdownField>, 'label' | 'children'>) => {
  return (
    <DropdownField label={''} {...props} css={inlineDropdownStyles}>
      {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
        <DropdownField.Option key={month} value={String(month)}>
          {month}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

export const WeekdayDropdown = (props: Omit<ComponentProps<typeof DropdownField>, 'label' | 'children'>) => {
  return (
    <DropdownField label={''} {...props} css={inlineDropdownStyles}>
      {monthlyWeekDayOptions.map((option) => (
        <DropdownField.Option key={option.id} value={option.id}>
          {option.displayName}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

export const NthWeekStringDropdown = (props: Omit<ComponentProps<typeof DropdownField>, 'label' | 'children'>) => {
  const { t } = useTranslation('schedule-settings');
  return (
    <DropdownField label={''} {...props} css={inlineDropdownStyles}>
      {[
        { id: 'first', displayName: t('First') },
        { id: 'second', displayName: t('Second') },
        { id: 'third', displayName: t('Third') },
        { id: 'fourth', displayName: t('Fourth') },
        { id: 'last', displayName: t('Last') },
      ].map((option) => (
        <DropdownField.Option key={option.id} value={option.id}>
          {option.displayName}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};

const inlineDropdownStyles = css({
  width: 'auto',
  fontWeight: theme.font.weight.regular,
});
